import { InferValueTypes } from "../service-types";
import * as actions from "./actions";
import { ClaimStatus } from "../user/types";

export enum ClaimAction {
  GET_CLAIM_RECORD = "GET_CLAIM_RECORD_BY_ID",
  SET_CLAIM_RECORD = "SET_CLAIM_RECORD",
  CLEAN_UP = "CLAIM_STATE_CLEAN_UP",
  SUBMIT_TICKET = "SUBMIT_TICKET",
  SEND_EMAIL = "SEND_EMAIL",
}

export interface ClaimState {
  id: string;
  claimNumber: string;
  email: string;
  phoneNumber: string;
  city: string;
  state: string;
  address1: string;
  address2: string;
  zip: string;
  WarrantyProgramName: string;
  claimFileDate: string;
  planNumber: string;
  dealerName: string;
  purchaseDate: Date;
  deliveryDate: Date;
  planAgreement: string;
  claimItems: ClaimItem[];
  status_code: string;
  status: ClaimStatus;
  denied: boolean;
  documents: Documents[];
  customerName: string;
  emails: EmailCommunication[];
  customerActionDetail: string;
}

export interface EmailCommunication {
  subject: string;
  from: {
    user_name: string;
    email: string;
  };
  to: {
    email: string;
  }[];
  time: string;
  sent: boolean;
  status: {
    type: string;
  }[];
  source: string;
}

export interface Documents {
  key: string;
  lastModified: string;
  size: Number;
  url: string;
  fileName: string;
}

export interface ClaimItem {
  id: string;
  status: string;
  claim_item_name: string;
  manufacturer: string;
  color: string;
  material: string;
  vendor: string;
  description: string;
  damages: ClaimItemDamage[];
}

export interface ClaimItemDamage {
  damage_category: string;
  specific_damage: string;
  damage_Area: string;
  when_did_it_happen: string | null;
  how_did_it_happen: string;
  did_you_take_any_steps_to_remedy: string;
  notes: string;
  claim_item_DA_status: string;
  denial_short_summary: string;
  denial_reason_code_lookup: string;
  bp_status: string;
}

export const ClaimScope = "Claim";

export type ClaimActionTypes = ReturnType<InferValueTypes<typeof actions>>;
